import type {ReactNode} from 'react'
import {Skeleton} from '@/components/ui/skeleton'
import {PaginationBar} from '@/components/ui/pagination-bar'
import {DataTable, type Column} from '@/components/data-table'
import {ListCard, ListEmptyState} from '@/components/section-card'
import type {Page} from '@/hooks/empresa/organizacion/use-businesses'
import {CARTERA_PAGE_SIZE} from '@/hooks/inci/cartera/use-cartera'

export function PaginatedDataTable<T extends {id: string}>({
  columns,
  data,
  isLoading,
  page,
  onPageChange,
  emptyMessage,
  title,
  toolbar,
  testId,
}: {
  columns: Column<T>[]
  data: Page<T> | undefined
  isLoading: boolean
  page: number
  onPageChange: (page: number) => void
  emptyMessage: string
  title?: ReactNode
  toolbar?: ReactNode
  testId?: string
}) {
  if (isLoading && !data) return <Skeleton className="h-64 w-full" />
  return (
    <ListCard
      testId={testId}
      title={title}
      toolbar={toolbar}
      footer={
        !!data?.total && (
          <PaginationBar page={page} pageSize={CARTERA_PAGE_SIZE} total={data.total} onPageChange={onPageChange} />
        )
      }>
      <DataTable
        columns={columns}
        rows={data?.items ?? []}
        rowKey={(row) => row.id}
        emptyState={<ListEmptyState title={emptyMessage} />}
      />
    </ListCard>
  )
}
